module.exports = __webpack_public_path__ + "img/gem-found-pink.a2ec8e0c.png";